<template>
  <div class="container-fluid mt-2 mb-5">
    <div class="row justify-content-start align-items-center">
      <div class="col-md-12">
        <h1 class="d-flex align-items-center">
          <span class="material-icons text-main-gradient me-2">menu</span>
          <strong>Bienvenido</strong>
        </h1>
        <p v-if="showConfigMessage" class="alert alert-info">
          Bienvenido al sistema. Por favor, completa tu configuración inicial para comenzar a usar la plataforma.
        </p>
        <p v-else>
          Nos alegra tenerte aquí. Este es tu espacio digital donde podrás gestionar de forma segura, sencilla y
          profesional todos los aspectos clínicos de tus pacientes.
        </p>
      </div>
      <div class="col-md-12" v-if="showConfigMessage">
        <ConfiguracionInicial></ConfiguracionInicial>
      </div>
      <div class="col-md-12 mt-2 mb-5" v-else>
        <div class="row">
          <div class="col-md-9 mt-3">
            <Calendario v-if="isUserLoaded" :personal_medico_id="storedUser.mainId" />
            <div class="card">
              <div class="card-body">
                <ConsultasHistorico v-if="isUserLoaded" :personal_medico_id="storedUser.mainId" />
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <PacienteMasVisitas v-if="isUserLoaded" :personal_medico_id="storedUser.mainId" />
              </div>
            </div>
          </div>

          <div class="col-md-3 mt-3 mb-5">
            <div class="card">
              <div class="card-body">
                <TotalConsultas v-if="isUserLoaded" :personal_medico_id="storedUser.mainId" />
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <TotalPacientes v-if="isUserLoaded" :personal_medico_id="storedUser.mainId" />
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <MedicamentosRecetados v-if="isUserLoaded" :personal_medico_id="storedUser.mainId" />
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <IngresosConsulta v-if="isUserLoaded" :personal_medico_id="storedUser.mainId" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions } from "vuex";
  import axios from "axios";
  import moment from "moment";
  // import TotalSensors from "@/views/Total-sensors.vue";
  // import LatestUsers from "@/views/LatestUsers.vue";
  // import LatestJobs from "@/views/LatestJobs.vue";
  // import LatestUserLogins from "@/views/LatestUserLogins.vue";
  import ActiveSensors from "@/views/Active-Inactive-Sensors.vue";
  import ConfiguracionInicial from "@/views/ConfiguracionInicial.vue";
  import TotalConsultas from "./TotalConsultas.vue";
  import TotalPacientes from "./TotalPacientes.vue";
  import ConsultasHistorico from "./ConsultasHistorico.vue";
  import MedicamentosRecetados from "./MedicamentosRecetados.vue";
  import IngresosConsulta from "./IngresosConsulta.vue";
  import Calendario from "./Calendario.vue";
import PacienteMasVisitas from "./PacienteMasVisitas.vue";
  var config = require("@/config/api.json");
  const API = config.api;
  export default {
    name: "Dashboard",
    components: {
      ConfiguracionInicial,
      TotalConsultas,
      TotalPacientes,
      ConsultasHistorico,
      MedicamentosRecetados,
      IngresosConsulta,
      PacienteMasVisitas,
      Calendario,
    },
    data() {
      return {
        storedUser: null,
        showConfigMessage: false,
        isUserLoaded: false // Nueva variable para controlar la carga del usuario
      };
    },

    mounted() {
      this.openLoading();
      document.body.style.filter = "blur(18px)";
      setTimeout(() => {
        const user = localStorage.getItem("user");
        if (user) {
          this.storedUser = JSON.parse(user);
          this.isUserLoaded = true; // Marcar como cargado cuando el usuario esté disponible
          if (!this.storedUser.displayName || !this.storedUser.photoURL) {
            this.showConfigMessage = true;
          }
          // Verificar paquete, contactos y especialidades
          axios
            .get(`${API}/verificar_paquete`, {
              params: { personal_medico_id: this.storedUser.mainId }
            })
            .then((response) => {
              const data = response.data;
              console.log("Respuesta del backend:", data);
              if (data.status === "success") {
                const contactos = data.contactos.totalRows;
                const especialidades = data.especialidades.totalRows;
                const paqueteActivo = data.paquete_activo.totalRows;
                const paquetes_expirados = data.paquetes_expirados;

                console.log("Contactos:", contactos);
                console.log("Especialidades:", especialidades);
                console.log("Paquete activo:", paqueteActivo);
                console.log("Paquetes expirados:", paquetes_expirados);

                if (paqueteActivo === 0) {
                  if(paquetes_expirados !=="No tiene paquetes expirados"){
                    console.log("Paquete expirado...");
                    this.$router.push("/home"); // Redirigir a /seleccionar-paquete si tiene paquetes expirados
                    console.log("storedUser", this.storedUser);
                    this.storedUser.expirado = 1;
                    localStorage.setItem("user", JSON.stringify(this.storedUser));
                  }else{
                    this.storedUser.expirado = 0;
                    localStorage.setItem("user", JSON.stringify(this.storedUser));
                    this.$router.push("/seleccionar-paquete"); // Redirigir a /seleccionar-paquete si no tiene paquete activo
                  }
                } else if (!this.storedUser.displayName || !this.storedUser.photoURL || Number(contactos) < 3 || Number(especialidades) < 1) {
                  console.log("Contactos, especialidades insuficientes o falta información del usuario");
                  this.storedUser.expirado = 0;
                    localStorage.setItem("user", JSON.stringify(this.storedUser));
                  this.$router.push("/inicio"); // Redirigir a /inicio si no cumple requisitos
                }
              } else {
                console.error("Error en la respuesta del backend:", data.message);
                this.$router.push("/inicio"); // Redirigir a /inicio en caso de error
              }
            })
            .catch((error) => {
              console.error("Error al verificar el paquete:", error);
              this.$router.push("/inicio"); // Redirigir a /inicio en caso de error
            });
        }
        document.body.style.filter = "blur(0px)";
        this.closeLoading();
      }, 1000);
    },
    methods: {},
  };
</script>